// Small form helpers shared by the account form, OOB editor and asset forms.

import type { TesterListItem } from '@frt/shared-types';

export const selectClass = 'block w-full rounded border border-slate-300 bg-white px-2 py-2 text-sm';

export function testerLabel(t: TesterListItem): string {
  return t.kind === 'person'
    ? t.short_name ?? `${t.first_name} ${t.last_name}`
    : t.short_business_name ?? t.business_name ?? `tester#${t.id}`;
}

export function Field({
  label,
  error,
  className,
  children,
}: {
  label: string;
  error?: string;
  className?: string;
  children: React.ReactNode;
}) {
  return (
    <label className={`block text-sm ${className ?? ''}`}>
      <span className="block text-slate-600">{label}</span>
      {children}
      {error && <span className="block text-xs text-red-600 mt-0.5">{error}</span>}
    </label>
  );
}
